import { Instance } from 'mobx-state-tree'
import { QuestionsProgressModelBase } from './QuestionsProgressModel.base'

/* The TypeScript type of an instance of QuestionsProgressModel */
export interface QuestionsProgressModelType extends Instance<typeof QuestionsProgressModel.Type> {}

/* A graphql query fragment builders for QuestionsProgressModel */
export {
  selectFromQuestionsProgress,
  questionsProgressModelPrimitives,
  QuestionsProgressModelSelector
} from './QuestionsProgressModel.base'

/**
 * QuestionsProgressModel
 */
export const QuestionsProgressModel = QuestionsProgressModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
